import type {
  Lia,
  LiaDetailResponse,
  LiaDetailResponseDTO,
  LiaDTO,
  LiaPurposeContext,
  LiaPurposeContextDTO,
  SoftDeleteLiaInput,
  UpdateLiaInput,
} from './lia.types';

export const parseLiaForFE = (dto: LiaDTO): Lia => ({
  id: dto.id,
  organizationId: dto.organization_id,
  processingPurposeId: dto.processing_purpose_id,
  legitimateInterestDescription: dto.legitimate_interest_description,
  necessityAssessment: dto.necessity_assessment,
  dataSubjectImpact: dto.data_subject_impact,
  reasonableExpectationsAssessment: dto.reasonable_expectations_assessment,
  balancingAssessment: dto.balancing_assessment,
  vulnerableDataSubjectsInvolved: dto.vulnerable_data_subjects_involved,
  vulnerableDataSubjectsComment: dto.vulnerable_data_subjects_comment,
  selectedSafeguards: dto.selected_safeguards,
  safeguardsDescription: dto.safeguards_description,
  rightToObjectHandling: dto.right_to_object_handling,
  conclusion: dto.conclusion,
  conclusionComment: dto.conclusion_comment,
  responsibleMembershipId: dto.responsible_membership_id,
  responsibleName: dto.responsible_name,
  assessmentDate: dto.assessment_date,
  nextReviewDate: dto.next_review_date,
  isDeleted: dto.is_deleted,
  deletedAt: dto.deleted_at,
  deletedByMembershipId: dto.deleted_by_membership_id,
  deletionReason: dto.deletion_reason,
  updatedAt: dto.updated_at,
  isComplete: dto.is_complete,
  validationStatus: dto.validation_status,
});

export const parseLiaContextForFE = (dto: LiaPurposeContextDTO): LiaPurposeContext => ({
  purposeId: dto.purpose_id,
  purposeText: dto.purpose_text,
  legalBasis: dto.legal_basis,
  legalBasisComment: dto.legal_basis_comment,
  retentionDescription: dto.retention_description,
  processingActivityId: dto.processing_activity_id,
  processingActivityName: dto.processing_activity_name,
  processingActivityStatus: dto.processing_activity_status,
});

export const parseLiaDetailResponseForFE = (dto: LiaDetailResponseDTO): LiaDetailResponse => ({
  lia: parseLiaForFE(dto.lia),
  context: parseLiaContextForFE(dto.context),
});

export const parseUpdateLiaForBE = (payload: UpdateLiaInput) => ({
  updated_at: payload.updatedAt,
  legitimate_interest_description: payload.legitimateInterestDescription.trim(),
  necessity_assessment: payload.necessityAssessment.trim(),
  data_subject_impact: payload.dataSubjectImpact.trim(),
  reasonable_expectations_assessment: payload.reasonableExpectationsAssessment.trim(),
  balancing_assessment: payload.balancingAssessment.trim(),
  vulnerable_data_subjects_involved: payload.vulnerableDataSubjectsInvolved,
  vulnerable_data_subjects_comment: payload.vulnerableDataSubjectsComment.trim(),
  selected_safeguards: payload.selectedSafeguards,
  safeguards_description: payload.safeguardsDescription.trim(),
  right_to_object_handling: payload.rightToObjectHandling.trim(),
  conclusion: payload.conclusion,
  conclusion_comment: payload.conclusionComment.trim(),
  responsible_membership_id: payload.responsibleMembershipId,
  assessment_date: payload.assessmentDate,
  next_review_date: payload.nextReviewDate,
});

export const parseSoftDeleteLiaForBE = (payload: SoftDeleteLiaInput) => ({
  updated_at: payload.updatedAt,
  deletion_reason: payload.deletionReason.trim(),
});

export const mapLiaToUpdateInput = (lia: Lia): UpdateLiaInput => ({
  updatedAt: lia.updatedAt,
  legitimateInterestDescription: lia.legitimateInterestDescription,
  necessityAssessment: lia.necessityAssessment,
  dataSubjectImpact: lia.dataSubjectImpact,
  reasonableExpectationsAssessment: lia.reasonableExpectationsAssessment,
  balancingAssessment: lia.balancingAssessment,
  vulnerableDataSubjectsInvolved: lia.vulnerableDataSubjectsInvolved,
  vulnerableDataSubjectsComment: lia.vulnerableDataSubjectsComment,
  selectedSafeguards: lia.selectedSafeguards,
  safeguardsDescription: lia.safeguardsDescription,
  rightToObjectHandling: lia.rightToObjectHandling,
  conclusion: lia.conclusion,
  conclusionComment: lia.conclusionComment,
  responsibleMembershipId: lia.responsibleMembershipId,
  assessmentDate: lia.assessmentDate,
  nextReviewDate: lia.nextReviewDate,
});
